import Modal from '@material-ui/core/Modal'
import AddIcon from '@material-ui/icons/Add'
import DatePicker from 'material-ui/DatePicker'
import MenuItem from 'material-ui/MenuItem'
import SelectField from 'material-ui/SelectField'
import TextField from 'material-ui/TextField'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Loader from '../loader/loader.jsx';
import 'react-toastify/dist/ReactToastify.css'



const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => ({

})
class ViewUserModalComp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            open: false,
            data: {},
            statusList: [],
            finished: false,
        };

        this.onFieldChange = this.onFieldChange.bind(this);
        this.handleModalOpen = this.handleModalOpen.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
    }

    handleModalOpen() {
        this.setState({ open: true })
    }
    handleModalClose() {
        this.setState({ open: false })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

    }

    checkObject(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop))
                return true
            return false
        }
    }

    handleClose = () => {
        this.setState({ disabled: true })
    }

    handleChecked(checked) {
        this.setState({ checked: checked })
    }

    onFieldChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    componentDidMount() {

    }

    componentDidUpdate() {

    }


    formatDate = (date) => {
        return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    }


    handleSelect = (event, index, value) => {
        this.setState({ gender: value })
    };

    render() {

        const { statusList } = this.state
        const { details, cardHolderName } = this.props
        return (

            <Modal
                open={this.props.open}
                onClose={this.props.onClose}
                style={{ top: '45px', overflow: 'scroll', }}>
                <div className="container col-sm-8" >
                    <div
                        className="modal-content "
                        style={{ border: "none", marginBottom: "10%" }}>
                        <div
                            className="modal-header"
                            style={{ borderBottom: "5px" }}>
                            <h4 style={{ fontSize: "16px", width: "97%" }}>
                                {/*`${this.state.firstName} ${this.state.lastName} - Details`*/}
                                KYC Details
                            </h4>

                            <div>
                                <AddIcon
                                    onClick={this.props.onClose}
                                    style={{ transform: 'rotate(45deg)', color: '#333', fontSize: "35px" }}>
                                </AddIcon>
                            </div>
                        </div>


                        <div className="modal-body">

                            {details && details.extraData ?
                                details.extraData.map((value, i) =>


                                    <div className="offset-sm-1 col-sm-10" style={{ paddingTop: "30px", }}>

                                        <div className="col">
                                            <div className="checkcard py-3 px-6">
                                                <div className="check-result-icon">
                                                    <div data-icon-name="f-pass" className="span has-tooltip icon round" >
                                                        <div style={{ width: '100%', height: '100%' }}>
                                                            <i className={details.extraData[i].kvpValue === "PASS" ? "fa fa-check-circle text-success fa-lg" : details.extraData[i].kypValue === "UNCHECKED" ? "fa fa-circle-o text-gray  fa-lg" : "fa fa-times-circle text-danger fa-lg"} style={{ padding: '0px' }}></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-content">
                                                    <div className="check-name f-headline3"> {value.kvpKey}</div>
                                                    <div className="description f-label"> {value.message ? details.extraData[i].message : "No blocklist matches found "}</div>
                                                </div>
                                                <div className="check-result"><h5><span className={(details.extraData[i].kvpValue === "PASS") ? "badge badge-success" : "badge badge-danger"}>{value.kvpValue}</span></h5></div>
                                            </div>
                                        </div>
                                    </div>
                                )
                                :
                                
                                <Loader />
                            }
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

ViewUserModalComp.propTypes = {

}

ViewUserModalComp.defaultProps = {

}

const ViewUserModal = connect(mapStateToProps, mapDispatchToProps)(ViewUserModalComp)
export default withRouter(ViewUserModal)


// WEBPACK FOOTER //
// ./src/components/myprofile/viewusermodal.jsx